import axios from "axios";
import { atom } from "recoil";

// ============================
// AXIOS INSTANCE
// ============================
const client = axios.create({
  // baseURL: "http://192.168.29.132:8000",
  // baseURL: "https://atoms-new.onrender.com",
  baseURL: "",   // relative — works from any server (local or deployed)
});

// ============================
// REQUEST INTERCEPTOR
// ============================
// ================= REQUEST =================
client.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ============================
// RESPONSE INTERCEPTOR (REFRESH TOKEN)
// ============================
// ================= RESPONSE =================
client.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // 🚫 DO NOT intercept login / logout
    if (
      originalRequest.url.includes("/api/login") ||
      originalRequest.url.includes("/api/logout")
    ) {
      return Promise.reject(error);
    }

    // 🔁 Access token expired
    if (
      error.response?.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      try {
        const refresh = localStorage.getItem("refresh_token");
        if (!refresh) throw new Error("No refresh token");

        const res = await axios.post(
          "/api/token/refresh/",
          { refresh }
        );

        localStorage.setItem("token", res.data.access);
        originalRequest.headers.Authorization =
          `Bearer ${res.data.access}`;

        return client(originalRequest);
      } catch (err) {
        // 🔥 ONLY HERE logout
        localStorage.clear();
        window.location.replace("/login");
      }
    }

    return Promise.reject(error);
  }
);

export default client;

// ============================
// RECOIL ATOMS
// ============================
export const machineDropdownAtom = atom({
  key: "globalCount",
  default: "",
});

export const globalapi = atom({
  key: "gbres",
  default: [],
});

export const timestampglobal = atom({
  key: "timestamp",
  default: "",
});

export const digitaloutputglobal = atom({
  key: "digitaloutput",
  default: [],
});
 